module.exports = __webpack_public_path__ + "img/rankC.cee1caef.svg";